import { render, staticRenderFns } from "./BatchQuery.vue?vue&type=template&id=06bb1987&scoped=true"
import script from "./BatchQuery.vue?vue&type=script&lang=js"
export * from "./BatchQuery.vue?vue&type=script&lang=js"
import style0 from "./BatchQuery.vue?vue&type=style&index=0&id=06bb1987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb1987",
  null
  
)

export default component.exports